import React from 'react';
import { Box, Container, List, ListItem } from '@mui/material';
import { LocalizedButton as Button, LocalizedListItemText as ListItemText } from '../components/i18n/LocalizedMui';
import Typography from '../components/i18n/LocalizedTypography';
import { Link as RouterLink } from 'react-router-dom';
import SEO from '../components/SEO';
import KundlistarSchema from '../components/KundlistarSchema';

const NadiAstrologySoftwarePage: React.FC = () => (
  <>
    <SEO
      title="Kundlistar Nadi Astrology Software - Nadi, BNN & Life Event Analysis"
      description="Kundlistar Nadi astrology software combines Nadi analysis, BNN directional charting, transit triggers, progressions and life event insights on web and Android."
      path="/nadi-astrology-software"
      keywords="Kundlistar Nadi astrology software, Nadi astrology app, BNN astrology software, Bhrigu Nandi Nadi, Nadi life events"
    />
    <KundlistarSchema />

    <Box sx={{ bgcolor: '#f7fbf8', py: { xs: 6, md: 10 } }}>
      <Container maxWidth="md">
        <Typography variant="h2" component="h1" sx={{ fontWeight: 600, mb: 2 }}>
          Kundlistar Nadi Astrology Software
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ lineHeight: 1.7 }}>
          Kundlistar helps users explore Nadi astrology and BNN through chart analysis,
          directional groups, combination strings, transit triggers and progression insights.
        </Typography>
      </Container>
    </Box>

    <Container maxWidth="md" sx={{ py: 7 }}>
      <Typography variant="h4" component="h2" sx={{ fontWeight: 600, mb: 2 }}>
        Nadi and BNN features in Kundlistar
      </Typography>
      <List>
        {[
          'Nadi life event analysis',
          'BNN directional chart and planet groups',
          'Nadi combination strings',
          'Transit triggers and yearly progression views',
          'Vedic, KP, Jaimini and Varshphal layers in one platform',
        ].map((item) => (
          <ListItem key={item} disableGutters>
            <ListItemText primary={item} />
          </ListItem>
        ))}
      </List>
      <Button component={RouterLink} to="/calculate" variant="contained" sx={{ mt: 2 }}>
        Try Nadi Analysis on Kundlistar
      </Button>
    </Container>
  </>
);

export default NadiAstrologySoftwarePage;
